import { RenderIf } from '@/components/RenderIf'
import TimeZoneLuxon from '@/components/TimeZoneLuxon'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { getCache } from '@/utils/cache'
import { Text } from '@conexasaude/conexa-hero'
import { Fragment, FunctionComponent } from 'react'
import { useHistory } from 'react-router-dom'
import { ChangePasswordForm } from '../../components/ChangePasswordForm'
import { LightHeader } from '../../components/LightHeader'
import useStyles from './styles'

const ChangePassword: FunctionComponent = () => {
  const { clinic, user } = useAuthContext()
  const styles = useStyles()
  const { push } = useHistory()

  const hasPasswordConfirmed = getCache('passwordConfirmed')

  if (hasPasswordConfirmed) {
    return (
      <Fragment>
        <LightHeader uniqueCode={clinic.uniqueCode} redirectTo="/" />

        <div css={styles.container}>
          <div css={styles.changePasswordNoise}></div>
          <ChangePasswordForm />
          <div css={styles.timeZoneSection}>
            <TimeZoneLuxon />
            <RenderIf condition={Boolean(user?.patientId)}>
              <Text renderAs="p" variant="microCopy">
                ID: {user?.patientId} | Clínica: {user.clinic?.name}
              </Text>
            </RenderIf>
          </div>
        </div>
      </Fragment>
    )
  }

  push('/')
  return null
}

export default ChangePassword
